import { useState } from "react";

import VirtualPTVideo from "./VirtualPTVideo";
import FirstVisit from "./FirstVisit";
import DiagnosisToDischarge from "./DiagnosisToDischarge";
import FindYourPath from "./FindYourPath";
import PoweredBy from "./PoweredBy";
import PostMessage from "./PostMessage";
import VPTFooterButton from "./VPTFooterButton";
import CustomButton from "../../../common/CustomButton";

function VPTWideScreenLayoutV2() {
    const [slides, setSlides] = useState([
        <VirtualPTVideo mobile={false} />,
        <FirstVisit />,
        <DiagnosisToDischarge />,
        <FindYourPath />,
        <PoweredBy />,
        // <PostMessage />,
    ]);

    return (
        <div id="v-pt-wide-screen-layout-v2">
            <div id="v-pt-wslv2-header">
                <div>
                    <img src="assets/images/virtualPT/indicare_logo.png" />
                </div>

                <h1> Welcome to indicare </h1>
            </div>

            {slides?.map((slide) => {
                return <div className="v-pt-wsl-slide-container">{slide}</div>;
            })}

            <VPTFooterButton
                title="START TREATMENT"
                action={() => {
                    window.open("https://go.oncehub.com/PTconsult", "_blank");
                }}
            />

            <CustomButton
                style={{marginBottom: "150px"}}
                className="active"
                onClick={() => {
                    window.open("https://go.oncehub.com/PTconsult", "_blank");
                }}
            >
                {"START TREATMENT"}
            </CustomButton>
        </div>
    );
}

export default VPTWideScreenLayoutV2;
